<template>
    <div v-if="value && value.count">
        <div class="btn btn-xs btn-default" @click="showDialog = true">
            Other Vendors: {{ value.count | numberFormat }}
        </div>

        <VendorInventoryItemDialog v-if="showDialog" :id="value.id" @hide="showDialog = false" />
    </div>
</template>

<script>
export default {
    components: {
        VendorInventoryItemDialog: require('@/pages/vendors/VendorInventoryItemDialog.vue').default,
    },
    props: ['value'],
    data() {
        return {
            showDialog: false,
        };
    },
};
</script>
